(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["SpreeSDK"] = factory();
	else
		root["SpreeSDK"] = root["SpreeSDK"] || {}, root["SpreeSDK"]["createFetchFetcher"] = factory();
})(global, () => {
return 